<template lang="pug">
.wagtail-form-with-text
  .wagtail-form-with-text__text
    h3 {{ value.title }}
    //- p {{ value.text }}
    p {{ pureText }}
  Form(:value="value.form").wagtail-form-with-text__form
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    pureText() {
      return this.value.text.replace(/[\\n\r]/g, ' ')
    }
  },
}
</script>

<style lang="scss" scoped>
.wagtail-form-with-text {
  width: 100%;
  padding: 170px 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  position: relative;

  &:before {
    content: "";
    // width: 100vw;
    height: 100%;
    background-color: $lightgrey;
    position: absolute;
    top: 0;
    left: 50%;
    margin-left: -50vw;
    z-index: 1;
  }

  &__text {
    position: relative;
    z-index: 22;
    max-width: 450px;

    h3 {
      color: $dark;
      margin-bottom: 30px;
      text-transform: uppercase;
      font-weight: bold;
    }

    p {
      color: $gray;
    }
  }

  &__form {
    position: relative;
    z-index: 22;
    max-width: 335px;
  }
}
</style>